import { render, staticRenderFns } from "./advertisingManagement.vue?vue&type=template&id=15c3d77c&scoped=true"
import script from "./advertisingManagement.vue?vue&type=script&lang=js"
export * from "./advertisingManagement.vue?vue&type=script&lang=js"
import style0 from "./advertisingManagement.vue?vue&type=style&index=0&id=15c3d77c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c3d77c",
  null
  
)

export default component.exports